import React, { useEffect, useState } from "react"
import { gql, useQuery } from "@apollo/client"

const QUERY = gql`
    query imagecache($urlpath: String) {
        imagecache(urlpath: $urlpath)
    }
`

function PPPictureBoxLoad(props) {
    const [imgLoaded, setImgLoaded] = useState(false)
    const { data } = useQuery(QUERY, {
        displayName: "PPPictureBoxLoad",
        fetchPolicy: "no-cache",
        variables: { urlpath: props?.image },
        skip: !props?.image
    })
    const imgFile = data?.imagecache || null

    useEffect(() => {
        setImgLoaded(false)
    }, [props?.image, imgFile])

    return (
        <>
            {imgFile ? (
                <img
                    style={imgLoaded ? {} : { display: "none" }}
                    className={props?.className}
                    src={imgFile}
                    alt={props?.alt}
                    width={props?.width}
                    height={props?.height}
                    onLoad={() => setImgLoaded(true)}
                />
            ) : null}
            <i
                className="far fa-image fa-5x defaultpictureproduct"
                style={imgLoaded ? { display: "none" } : { display: "unset" }}
            ></i>
        </>
    )
}

export default PPPictureBoxLoad
